<template>
  <div class="country-page">
    <BContainer class="bg-country-page" fluid v-if="country">
      <BContainer>
        <BRow>
          <BCol cols="6" class="justify-content-center country-intro" v-if="country.players">
            <div>
              <h1>{{ country.country }}</h1>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
              </p>
            </div>
          </BCol>
          <BCol cols="6" class="justify-content-center" v-if="country.players">
            <div class="p-5">
              There {{ country.players.length == 1 ? `is` : `are` }} {{ country.players.length }} Power Players from {{ listCountries.length }} {{ listCountries.length == 1 ? `country` : `countries` }}
            </div>
          </BCol>
        </BRow>
      </BContainer>
    </BContainer>
    <BContainer class="bg-country-players" fluid>
      <BContainer>
        <BRow>
          <BCol cols="12">
            <BRow>
              <BCol cols="12" class="mb-5">
                <h3>Explore the Power Players in this country</h3>
              </BCol>
            </BRow>
            <BRow>
              <BCol cols="3" class="mb-5 text-left">

                <div class="countries_filter">
                  <BFormGroup>
                    <BFormRadioGroup
                    id="btn-radios-3"
                    :options="listCountries"
                    name="radio-btn-stacked"
                    buttons
                    stacked />
                  </BFormGroup>
                </div>

              </BCol>
              <BCol cols="8" offset="1" class="mb-5">
                <PlayersGrid :players="country.players" />
              </BCol>
            </BRow>
          </BCol>
        </BRow>
      </BContainer>
    </BContainer>
  </div>
</template>

<script>
  import utilsMixins from '@/mixins/utils'
  import countryMixins from '@/mixins/country'
  import PlayersGrid from '@/components/PlayersGrid.vue'

  export default {
    name: 'Country',
    mixins: [countryMixins, utilsMixins],
    components: {
      PlayersGrid
    },
    mounted() {
      this.findCountry(this.$route.params.country_id)
    }
  }
</script>

<style lang="scss">
  .country-page {
    .country-intro {
      border-right: dashed 1px #fff;
    }
  }

  .countries_filter {

    label {
      margin-bottom: 5px;
      
      &.btn > span {
        font-size: 14px;
        display: inline-block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .btn-secondary {
      margin-bottom: 5px !important;
      color: #000;
      background: #1d1d1d30;
      border: none;
    }

    .btn-group-toggle {
      width: 100%;
    }
  }

  .bg-country-page {
    padding: 25vh 0;
    background: var(--app-color-black);
    color: #fff;
  }

  .bg-country-players {
    padding: 5vh 0;

    h3 {
      color: var(--app-color-black);
    }
  }
</style>
